 <div *ngIf="termsCondictios">
 <button
    id="card-button-pay"
    class="btn btn-lg btn-book-now btn-block"
    (click)="getInitPayments()"
    *ngIf="getPayWidthCard">Pay with card</button>
<form id="payment-form" *ngIf="!getPayWidthCard">
      <div id="card-container"></div>
      <button
      (click)="getHandlePaymentMethodSubmission()"
      id="card-button"
      type="button">Pay ${{getValue()}}</button>
</form>
<div id="payment-status-container"></div>
</div>
